import {
  CREATE_KB_MESSAGES_FAILED, CREATE_KB_MESSAGES_REQUESTED,
  CREATE_KB_MESSAGES_SUCCESS,
  GET_KB_MESSAGES_FAILED,
  GET_KB_MESSAGES_REQUESTED,
  GET_KB_MESSAGES_SUCCESS,
  CLEAR_KB_MESSAGES_ERROR
} from './actionTypes'

export const getMessages = payload => ({
  type: GET_KB_MESSAGES_REQUESTED,
  payload
})


export const getMessagesSuccess = payload => ({
  type: GET_KB_MESSAGES_SUCCESS,
  payload
})

export const getMessagesFailed = payload => ({
  type: GET_KB_MESSAGES_FAILED,
  payload
})

export const clearMessagesError = payload => ({
  type: CLEAR_KB_MESSAGES_ERROR,
  payload
})

export const createMessage = payload => ({
  type: CREATE_KB_MESSAGES_REQUESTED,
  payload
})

export const createMessageSuccess = payload => ({
  type: CREATE_KB_MESSAGES_SUCCESS,
  payload
})

export const createMessageFailed = payload => ({
  type: CREATE_KB_MESSAGES_FAILED,
  payload
})
